export enum ResourceAuthEnum {
//物资入库
    //物资入库(采购新增)
    ASSETS_S_P_AD = 'assets.s.p.ad',
    //物资入库(采购更新)
    ASSETS_S_P_ED = 'assets.s.p.ed',
    //物资入库(打印单据)
    ASSETS_S_P_PRINT = 'assets.s.p.print',
    //物资入库(导出)
    ASSETS_S_P_EX = 'assets.s.p.ex',
    //物资入库(打印标签)
    ASSETS_S_P_PRINT_LABEL = 'assets.s.p.print-label',
    //物资入库(转领取)
    ASSETS_S_P_TRANS_S = 'assets.s.p.trans-s',
    //物资入库(保存)
    ASSETS_S_P_ED_SAVE = 'assets.s.p.ed.save',
    //物资入库(返回)
    ASSETS_S_P_ED_BACK = 'assets.s.p.ed.back',
    
//物资领取
    //物资领取(领取新增)    
    ASSETS_S_S_AD='assets.s.s.ad',
    //物资领取(领取更新)
    ASSETS_S_S_ED='assets.s.s.ed',
    //物资领取(打印单据)
    ASSETS_S_S_PRINT='assets.s.s.print',
    //物资领取(导出)
    ASSETS_S_S_EX='assets.s.s.ex',
    //物资领取(打印标签)
    ASSETS_S_S_PRINT_LABEL='assets.s.s.print-label',
    //物资领取(保存)
    ASSETS_S_S_ED_SAVE='assets.s.s.ed.save',
    //物资领取(返回)
    ASSETS_S_S_ED_BACK='assets.s.s.ed.back',
    //物资领取(详情-物品新增)
    ASSETS_S_S_ED_AD='assets.s.s.ed.ad',
    //物资领取(详情-物品删除)
    ASSETS_S_S_ED_DEL='assets.s.s.ed.del',
    //物资领取(详情-下载模板)
    ASSETS_S_S_ED_DLOAD='assets.s.s.ed.dload',
    //物资领取(详情-导入)
    ASSETS_S_S_ED_IM='assets.s.s.ed.im',
    //物资领取(详情-打印标签)
    ASSETS_S_S_ED_PRINT_LABEL='assets.s.s.ed.print-label',

//物资归还
    //物资归还(归还新增)
    ASSETS_S_R_AD ='assets.s.r.ad',
    //物资归还(打印)
    ASSETS_S_R_PRINT ='assets.s.r.print',
    //物资归还(导出)
    ASSETS_S_R_EX ='assets.s.r.ex',
    //物资归还(详情_物品新增)
    ASSETS_S_R_ED_AD ='assets.s.r.ed.ad',
    //物资归还(详情_物品删除)
    ASSETS_S_R_ED_DEL ='assets.s.r.ed.del',
    //物资归还(保存)
    ASSETS_S_R_ED_SAVE ='assets.s.r.ed.save',
    //物资归还(返回)
    ASSETS_S_R_ED_BACK ='assets.s.r.ed.back',

//物资报废
    //物资报废(报废新增)
    ASSETS_S_C_AD ='assets.s.c.ad',
    //物资报废(打印)
    ASSETS_S_C_PRINT ='assets.s.c.print',
    //物资报废(导出)
    ASSETS_S_C_EX ='assets.s.c.ex',
    //物资报废(详情_物品新增)
    ASSETS_S_C_ED_AD ='assets.s.c.ed.ad',
    //物资报废(详情_物品删除)
    ASSETS_S_C_ED_DEL ='assets.s.c.ed.del',
    //物资报废(保存)
    ASSETS_S_C_ED_SAVE ='assets.s.c.ed.save',
    //物资报废(返回)
    ASSETS_S_C_ED_BACK ='assets.s.c.ed.back',

//物资转移
    //物资转移(转移新增)
    ASSETS_S_M_AD ='assets.s.m.ad',
    //物资转移(打印单据)
    ASSETS_S_M_PRINT ='assets.s.m.print',
    //物资转移(导出)
    ASSETS_S_M_EX ='assets.s.m.ex',
    //物资转移(打印标签)
    ASSETS_S_M_PRINT_LABEL ='assets.s.m.print-label',
    //物资转移(详情-物品新增)
    ASSETS_S_M_ED_AD ='assets.s.m.ed.ad',
    //物资转移(详情-物品删除)
    ASSETS_S_M_ED_DEL ='assets.s.m.ed.del',
    //物资转移(详情-打印标签)
    ASSETS_S_M_ED_PRINT_LABEL ='assets.s.m.ed.print-label',
    //物资转移(保存)
    ASSETS_S_M_ED_SAVE ='assets.s.m.ed.save',
    //物资转移(返回)
    ASSETS_S_M_ED_BACK ='assets.s.m.ed.back',

//资产盘点
    //资产盘点(盘点新增)
    ASSETS_ST_STTAKE_AD='assets.st.sttake.ad',
    //资产盘点(盘点编辑)
    ASSETS_ST_STTAKE_ED='assets.st.sttake.ed',
    //资产盘点(盘点完成)
    ASSETS_ST_STTAKE_FINISH='assets.st.sttake.finish',
    //资产盘点(盘点审核)
    ASSETS_ST_STTAKE_EXAMINE='assets.st.sttake.examine',
    //资产盘点(导出)
    ASSETS_ST_STTAKE_EX='assets.st.sttake.ex',
    //资产盘点(保存)
    ASSETS_ST_STTAKE_ED_SAVE='assets.st.sttake.ed.save',
    //资产盘点(返回)
    ASSETS_ST_STTAKE_ED_BACK='assets.st.sttake.ed.back',
    //资产盘点(详情_下载模板)
    ASSETS_ST_STTAKE_ED_DLOAD='assets.st.sttake.ed.dload',
    //资产盘点(详情_导入)
    ASSETS_ST_STTAKE_ED_IM='assets.st.sttake.ed.im',
//资产清单
    //资产清单(导出)
    ASSETS_LIST_EX='assets.s.List.ex',
    ASSETS_LIST_EXPORT='assets.List.export',
 //基础数据
    //基础数据(资产分类)
    ASSETS_DATA_CLASS = 'assets.data.class',
    //基础数据(增加同级)
    ASSETS_DATA_CLASS_BRO = 'assets.data.class.bro',
    //基础数据(分类-详情取消)
    ASSETS_DATA_CLASS_ED_CANCEL = 'assets.data.class.ed.cancel',
    //基础数据(增加下级)
    ASSETS_DATA_CLASS_SUB = 'assets.data.class.sub',
    //基础数据(分类-详情保存)
    ASSETS_DATA_CLASS_ED_SAVE = 'assets.data.class.ed.save',
//仓库管理
    //仓库管理(仓库新增)
    ASSETS_DATA_W_AD = 'assets.data.w.ad',
    //仓库管理(仓库编辑)
    ASSETS_DATA_W_ED = 'assets.data.w.ed',
    //仓库管理(货位新增)
    ASSETS_DATA_W_EDD_SHELF_AD = 'assets.data.w.ed.shelf.ad',
    //仓库管理(货位编辑)
    ASSETSA_DATA_W_EDD_SHELF_ED = 'assets.data.w.ed.shelf.ed',
    //基础数据(货位下载模板)
    ASSETS_DATA_W_ED_SHELF_DLOAD = 'assets.data.w.ed.shelf.dload',
    //仓库管理(货位导入)
    ASSETS_DATA_W_ED_SHELF_IM = 'assets.data.w.ed.shelf.im',
    //仓库管理(货位导出)
    ASSETS_DATA_W_ED_SHELF_EX = 'assets.data.w.ed.shelf.ex',
//数据字典
    // 数据字典(资源名称数据字典)
    ASSETS_DATA_DICT = 'assets.data.dict',
    // 数据字典(增加同级)
    ASSETS_DATA_DICT_BRO = 'assets.data.dict.bro',
    // 数据字典(字典-详情取消)
    ASSETS_DATA_DICT_ED_CANCEL = 'assets.data.dict.ed.cancel',
    // 数据字典(增加下级)
    ASSETS_DATA_DICT_SUB = 'assets.data.dict.sub',
    // 数据字典(字典-详情保存)
    ASSETS_DATA_DICT_ED_SAVE = 'assets.data.dict.ed.save',
// 审批设置
    ASSETS_DATA_EXAMINE = 'assets.data.examine',

//申请列表
    //申请列表(申请管理)
    ASSETS_AP_L ='assets.ap.l',
    //申请列表(申请新增)
    ASSETS_AP_L_AD ='assets.ap.l.ad',
    //申请列表(申请编辑)
    ASSETS_AP_L_ED ='assets.ap.l.ed',
    //申请列表(申请审批)
    ASSETS_AP_L_EXAMINE ='assets.ap.l.examine',
    //申请列表(保存)
    ASSETS_AP_L_ED_SAVE ='assets.ap.l.ed.save',
    //申请列表(返回)
    ASSETS_AP_L_ED_BACK ='assets.ap.l.ed.back',


}